import { forwardRef } from 'react';
import { Upload as BaseUpload } from 'antd';
import { useTrigger } from './useTrigger';
import type { ReactElement, Ref } from 'react';
import type { UploadProps, UploadRef, UploadFileParam } from './types';

/**
 * 上传文件组件，需要通过onUpload自行实现上传文件的接口
 */
function UploadComponent(props: UploadProps, ref: Ref<UploadRef>): ReactElement {
  const { uploader } = useTrigger(ref);
  const options: UploadProps = {
    ...props,

    /**
     * 限制上传文件类型
     */
    accept: props.accept ?? '.xlsx, .xls',

    /**
     * 点击Upload组件区域，拉起文件选择框
     */
    openFileDialogOnClick: true,

    /**
     * 不显示选中文件列表
     */
    showUploadList: false,

    /**
     * 将文件返回给调用端，自行使用接口上传
     */
    customRequest: async event => {
      if (event.file != null) {
        await props.onUpload(event.file as Blob);
      }
    }
  };

  return (
    <div ref={uploader}>
      <BaseUpload {...options} >{props.children}</BaseUpload>
    </div>
  );
}

export const Upload = forwardRef(UploadComponent);
export type { UploadRef, UploadProps, UploadFileParam };
